import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { PartnerAuthGuard, PartnerPortalProviders, PartnerPortalShell } from './PartnerPortalLayout';
import PartnerBusinessPage from './pages/PartnerBusinessPage';
import PartnerDashboardPage from './pages/PartnerDashboardPage';
import PartnerEditProfilePage from './pages/PartnerEditProfilePage';
import PartnerLoginPage from './pages/PartnerLoginPage';
import PartnerWizardPage from './pages/PartnerWizardPage';

export const PartnerPortalLoginRoutes: React.FC = () => (
  <PartnerPortalProviders>
    <PartnerLoginPage />
  </PartnerPortalProviders>
);

export const PartnerPortalPanelRoutes: React.FC = () => (
  <PartnerPortalProviders>
    <Routes>
      <Route element={<PartnerPortalShell />}>
        <Route element={<PartnerAuthGuard />}>
          <Route path="nuevo" element={<PartnerWizardPage />} />
          <Route path=":businessId/editar" element={<PartnerEditProfilePage />} />
          <Route path=":businessId" element={<PartnerBusinessPage />} />
          <Route index element={<PartnerDashboardPage />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/partners/panel" replace />} />
    </Routes>
  </PartnerPortalProviders>
);

const PartnerPortalRoutes: React.FC = () => (
  <Routes>
    <Route path="registro" element={<PartnerPortalLoginRoutes />} />
    <Route path="panel/*" element={<PartnerPortalPanelRoutes />} />
    <Route path="*" element={<Navigate to="/partners/registro" replace />} />
  </Routes>
);

export default PartnerPortalRoutes;
